import React, { memo } from 'react';
import { useTransition, animated } from '@react-spring/web';

import { ICarouselProp } from '../AllForCarousel';
import classNames from 'classnames';
import getEffectConfig from './EffectConfig';
import imageUtil from '../../../utils/image';
import { getWatermarks } from '../../../utils/util';
import './index.scss';

function CommonEffect(props: ICarouselProp) {
  const { images, config, index, setIndex } = props;
  const { effect } = config;

  const currentEffect = getEffectConfig(effect);
  const transitions = useTransition(index, currentEffect);

  console.log(images.length, 'images.length');

  return (
    <div className={classNames('component-carousel common-effect', effect)}>
      {transitions((style, i) => {
        // 如果刚好删除掉当前正在播放的这张照片，会出现images[i]不存在的问题
        if (!images[i]) {
          return null;
        }
        return (
          <animated.div
            className={'bg'}
            // 点击不再做处理了
            // onClick={() => setIndex(state => (state + 1) % images.length)}
            style={{
              ...style,
              backgroundImage: `url(${imageUtil.style(
                images[i].hash,
                'wx_1920_n', // 保持和大图页一致
                { watermark: getWatermarks() },
                images[i].id
              )})`
            }}
          />
        );
      })}
    </div>
  );
}

// 避免同一个index因为一些原因被重复渲染（比如其他的op显示等一些改动)，导致animate重新被执行
export default memo(CommonEffect, function(pre, next) {
  // index相同就不需要重新考虑渲染的问题
  // 不需要判断图片的长度，否则增改的时候会出现重新被渲染的问题
  return pre.index === next.index;
});
